const TEL_BOOKING = 2;
const ONLINE_BOOKING = 4;
const AI_ONLINE = 8;
/* tslint:disable:no-bitwise */
/**
 * 是否为AI馆
 */
export function isAI(info: any): number {
  return info.online_status & AI_ONLINE;
}

/**
 * 是否为合作馆
 */
export function isCooperate(info: any): number {
  return info.online_status & ONLINE_BOOKING;
}

/**
 * 是否为电话订场
 */
export function isTelBooking(info: any): number {
  if (isAI(info) || isCooperate(info)) {
    return 0;
  }

  return info.online_status & TEL_BOOKING;
}

/**
 * 当前页面的父节点路径
 * @param obj 菜单
 * @param item 当前页面的path
 */
export function find(obj: any, item: any): any {
  for (const key in obj) {
    if (obj[key] && typeof obj[key] === 'object') {
      const result = find(obj[key], item);
      if (result) {
        result.unshift(key);
        return result;
      }
    } else if (obj[key] === item) {
      return [key];
    }
  }
}
